import Aos from 'aos';
import React, { useContext, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import PublicRoutes from './routes/PublicRoutes';
import PrivateRoutes from './routes/PrivateRoutes';
import { AuthContext } from './context/AuthProvider';
import InitLoader from './layouts/InitLoader';
import { refreshToken, sportalokaClient } from './api/sportaloka-client';

function App() {
  const [state, dispatch] = useContext(AuthContext);
  const appRoutes = useRoutes(state.accessToken ? PrivateRoutes : PublicRoutes);

  sportalokaClient.interceptors.request.use((config) => {
    const apiKey = process.env.REACT_APP_SPORTALOKA_API_KEY ?? '';
    config.headers['x-sportaloka-api-key'] = apiKey;
    return config;
  });

  sportalokaClient.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response.data.code == '100105' || error.response.data.code === '100203') {
        dispatch({ type: 'SIGNOUT' });
        return Promise.reject(error);
      }
      if (error.response.data.code === '100103') {
        try {
          const response = await refreshToken();
          const responseData = response.data.data;
          dispatch({
            type: 'SIGNIN',
            payload: {
              accessToken: 'Bearer ' + responseData.access_token,
              refreshToken: responseData.refresh_token,
              userProfile: responseData.user,
              sessionId: responseData.user.session_id
            }
          });
          error.config.headers['Authorization'] = 'Bearer ' + responseData.access_token;
          return sportalokaClient(error.config);
        } catch (refreshTokenError) {
          const refreshTokenErrorStatus = refreshTokenError.response.status;
          if (refreshTokenErrorStatus === 401) {
            dispatch({ type: 'SIGNOUT' });
          }
          return Promise.reject(refreshTokenError);
        }
      }
      return Promise.reject(error);
    }
  );

  useEffect(() => {
    Aos.init({
      duration: 1200,
      once: true
    });
  }, []);

  return <div className="App">{state.init_loading ? <InitLoader /> : appRoutes}</div>;
}

export default App;
